import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {DateLabelComponent} from "./date-label.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
    ],
    declarations: [
        DateLabelComponent,
    ],
    exports: [
        DateLabelComponent,
    ],
})
export class DateLabelModule {
}